import { Divider, Typography } from '@mui/material'
import { PageWithAppBar } from '$common/page-with-app-bar'
import { AppBarBackTitle } from '$common/app-bar/app-bar-back-title'
import { closeContactUs } from '$logic/router'
import { SettingsSection } from '$common/settings-section'
import { t } from '$i18n'

function ContactUsItem({
  title,
  description,
}: {
  title: string
  description: string
}) {
  return (
    <>
      <div
        style={{
          height: '70px',
          padding: '10px 0',
          gap: '4px',
          backgroundColor: 'white',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography variant="subtitle3" color="gray">
          {title}
        </Typography>
        <Typography variant="subtitle3">{description}</Typography>
      </div>
    </>
  )
}

export function ContactUs() {
  return (
    <PageWithAppBar
      appBar={
        <AppBarBackTitle
          title={t('myAccount.contactUs')}
          onBack={closeContactUs}
        />
      }
    >
      <SettingsSection
        sx={{
          paddingRight: '16px',
        }}
      >
        <>
          <ContactUsItem
            title={t('contactUs.address.title')}
            description={t('contactUs.address.description')}
          />
          <Divider />
          <ContactUsItem
            title={t('contactUs.email.title')}
            description={t('contactUs.email.description')}
          />
          <Divider />
          <ContactUsItem
            title={t('contactUs.phone.title')}
            description={t('contactUs.phone.description')}
          />
        </>
      </SettingsSection>
    </PageWithAppBar>
  )
}
